import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "totals-row" }
const _hoisted_11 = { class: "text-left font-weight-bold" }
const _hoisted_12 = { class: "text-left font-weight-bold" }
const _hoisted_13 = { class: "text-left font-weight-bold" }
const _hoisted_14 = { class: "text-left font-weight-bold" }
const _hoisted_15 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_16 = ["viewBox"]
const _hoisted_17 = ["xlink:href", "height", "width"]
const _hoisted_18 = ["id", "points", "onClick", "onMouseover", "onMouseout"]
const _hoisted_19 = ["points", "onMouseover", "onMouseout", "onClick"]
const _hoisted_20 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_21 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { key: 6 }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_edit = _resolveComponent("v-btn-edit")!
  const _component_v_btn_add = _resolveComponent("v-btn-add")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_DocumentLoanOCR = _resolveComponent("DocumentLoanOCR")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UploadDocument = _resolveComponent("UploadDocument")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_BankAccountSelector = _resolveComponent("BankAccountSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "6",
          class: "pl-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"height":"calc(100vh - 82px)","overflow-y":"auto"},
              class: "default_card_wm elevation-0 rounded-l-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "d-flex align-left text-left"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.mode !== 'GeneralLedger' && _ctx.goBackHistory)
                          ? (_openBlock(), _createBlock(_component_v_btn_back, {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"])),
                              "data-cy": "document-back"
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.isPDF && _ctx.zoomManager && _ctx.windowStep === 'display-pdf')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_v_btn_icon, {
                                icon: "$oss-zoom-out",
                                disabled: _ctx.zoomManager.disableZoomOut(),
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.zoomManager.zoomOut()), ["stop"]))
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_v_btn_icon, {
                                icon: "$oss-focus",
                                disabled: _ctx.zoomManager.disableResetZoom(),
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.zoomManager.resetZoom()), ["stop"]))
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_v_btn_icon, {
                                icon: "$oss-zoom-in",
                                disabled: _ctx.zoomManager.disableZoomIn(),
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.zoomManager.zoomIn()), ["stop"]))
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_v_btn_icon, {
                                class: "my-0 mr-1",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
                                        _ctx.documentPdfRotation = _ctx.rotate(
                                            'left',
                                            _ctx.zoomManager,
                                            _ctx.documentPdfRotation,
                                        )
                                    ), ["stop"])),
                                icon: "$fa-undo"
                              }),
                              _createVNode(_component_v_btn_icon, {
                                class: "my-0",
                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
                                        _ctx.documentPdfRotation = _ctx.rotate(
                                            'right',
                                            _ctx.zoomManager,
                                            _ctx.documentPdfRotation,
                                        )
                                    ), ["stop"])),
                                icon: "$fa-redo"
                              }),
                              (_ctx.document.signedUrlOCR)
                                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                    key: 0,
                                    icon: "$oss-eye",
                                    disabled: _ctx.zoomManager.disableResetZoom(),
                                    class: "ml-1",
                                    loading: _ctx.ocrLoading,
                                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.onOCRChanged()), ["stop"]))
                                  }, null, 8, ["disabled", "loading"]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.selectedText,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedText) = $event)),
                                id: "selectedText",
                                "hide-details": "",
                                class: "ml-2 small-prepend-icon",
                                "append-inner-icon": "$oss-close",
                                "onClick:appendInner": _ctx.emptySelectedText
                              }, null, 8, ["modelValue", "onClick:appendInner"]), [
                                [_vShow, _ctx.selectedText]
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.isPDF && _ctx.windowStep === 'display-pdf')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_v_btn_icon, {
                                icon: "$oss-zoom-out",
                                onClick: _withModifiers(_ctx.zoomOutPdf, ["stop"])
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_v_btn_icon, {
                                icon: "$oss-focus",
                                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.resetZoomPdf()), ["stop"]))
                              }),
                              _createVNode(_component_v_btn_icon, {
                                icon: "$oss-zoom-in",
                                onClick: _withModifiers(_ctx.zoomInPdf, ["stop"])
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_v_btn_icon, {
                                class: "my-0 mr-1",
                                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (
                                        _ctx.documentPdfRotation = _ctx.rotate(
                                            'left',
                                            _ctx.zoomManager,
                                            _ctx.documentPdfRotation,
                                        )
                                    ), ["stop"])),
                                icon: "$fa-undo"
                              }),
                              _createVNode(_component_v_btn_icon, {
                                class: "my-0",
                                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (
                                        _ctx.documentPdfRotation = _ctx.rotate(
                                            'right',
                                            _ctx.zoomManager,
                                            _ctx.documentPdfRotation,
                                        )
                                    ), ["stop"])),
                                icon: "$fa-redo"
                              })
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pr-3 d-flex align-center justify-end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tooltip, {
                          text: _ctx.editMode ? _ctx.$t('emprunts.discard') : _ctx.$t('emprunts.edit')
                        }, {
                          activator: _withCtx(({ props }) => [
                            (_ctx.editedLoan.length > 0)
                              ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
                                  key: 0,
                                  class: "mt-1 mx-2 d-flex flex-end rounded-circle bg-primary edit-emprunt",
                                  size: "small",
                                  id: "editEmprunts",
                                  onClick: _ctx.toggleEditMode,
                                  w: ""
                                }, props), {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.editMode ? "$fa-redo" : "$oss-edit"), 1)
                                  ]),
                                  _: 2
                                }, 1040, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["text"]),
                        _createVNode(_component_v_btn_toggle, {
                          modelValue: _ctx.windowStep,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.windowStep) = $event)),
                          rounded: "xl",
                          class: "mt-1",
                          density: "compact",
                          divided: "",
                          variant: "outlined",
                          color: "secondary",
                          mandatory: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              value: 'table',
                              icon: "$fa-table"
                            }),
                            _createVNode(_component_v_btn, {
                              value: 'display-accounting-lines',
                              icon: "$fa-list"
                            }),
                            _createVNode(_component_v_btn, {
                              value: 'display-pdf',
                              icon: "$oss-file",
                              disabled: !_ctx.document.signedUrl,
                              readonly: !_ctx.document.signedUrl
                            }, null, 8, ["disabled", "readonly"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_v_menu, {
                          "offset-y": "",
                          class: "pl-2"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              nav: "",
                              rounded: "xl"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.isAccountingUser)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      modelValue: _ctx.windowStep,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.windowStep) = $event)),
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.windowStep = 'display-activity')),
                                      disabled: !_ctx.document.id
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[76] || (_cache[76] = [
                                            _createTextVNode("$oss-activity")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("emprunts.afficher-activite")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "disabled"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_divider, { class: "mb-2" }),
                                (_ctx.document.signedUrl)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      onClick: _ctx.startDownloadFile
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[77] || (_cache[77] = [
                                            _createTextVNode("$oss-download")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("emprunts.telecharger-doc")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_list_item, {
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.uploadDocumentDialog = true)),
                                  disabled: !_ctx.document.id
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[78] || (_cache[78] = [
                                        _createTextVNode("$oss-upload")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("emprunts.ajouter-document")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]),
                                (_ctx.restartAnalysis)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 2,
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.analyseDocumentDialog = true))
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                          default: _withCtx(() => _cache[80] || (_cache[80] = [
                                            _createTextVNode("$oss-scan")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[79] || (_cache[79] = [
                                            _createTextVNode("Relancer l'analyse")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_divider, { class: "mb-2" }),
                                _createVNode(_component_v_list_item, {
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.deleteDocumentDialog = true)),
                                  disabled: _ctx.disabledDelete,
                                  color: "error",
                                  active: !_ctx.disabledDelete
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: "primary",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[81] || (_cache[81] = [
                                        _createTextVNode("$oss-trash")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("emprunts.supprimer")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "active"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window, {
                          modelValue: _ctx.windowStep,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.windowStep) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { value: 'table' }, {
                              default: _withCtx(() => [
                                (!_ctx.$vuetify.display.mobile)
                                  ? (_openBlock(), _createBlock(_component_v_data_table, {
                                      key: 0,
                                      headers: _ctx.headers,
                                      items: _ctx.editedLoan,
                                      class: "table",
                                      "fixed-header": "",
                                      height: "90vh",
                                      "items-per-page": -1,
                                      density: "compact"
                                    }, {
                                      item: _withCtx((props) => [
                                        _createElementVNode("tr", {
                                          class: _normalizeClass(props.item.selected ? 'info' : '')
                                        }, [
                                          _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.month), 1),
                                          _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.dueAmountStartPeriod,
                                                            undefined,
                                                        )), 1),
                                          _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.monthlyPayment,
                                                            undefined,
                                                        )), 1),
                                          _createElementVNode("td", _hoisted_5, [
                                            _createVNode(_component_v_text_field, {
                                              modelValue: 
                                                            props.item.formattedValues.amortisation
                                                        ,
                                              "onUpdate:modelValue": ($event: any) => ((
                                                            props.item.formattedValues.amortisation
                                                        ) = $event),
                                              "aria-label": _ctx.$t('emprunts.amortissement'),
                                              class: _normalizeClass({
                                                            'editable-field': _ctx.editMode,
                                                            modified:
                                                                props.item.modifiedFields.includes(
                                                                    'amortisation',
                                                                ),
                                                            'hide-input': !_ctx.editMode,
                                                        }),
                                              density: "compact",
                                              type: "text",
                                              "hide-details": "",
                                              onInput: ($event: any) => (
                                                            _ctx.handleInput(
                                                                props.item,
                                                                'amortisation',
                                                                $event,
                                                            )
                                                        ),
                                              onBlur: ($event: any) => (
                                                            _ctx.onBlurAction(props.item, 'amortisation')
                                                        )
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label", "class", "onInput", "onBlur"])
                                          ]),
                                          _createElementVNode("td", _hoisted_6, [
                                            _createVNode(_component_v_text_field, {
                                              "aria-label": 
                                                            _ctx.$t('emprunts.monthly-interest')
                                                        ,
                                              modelValue: 
                                                            props.item.formattedValues
                                                                .monthlyInterest
                                                        ,
                                              "onUpdate:modelValue": ($event: any) => ((
                                                            props.item.formattedValues
                                                                .monthlyInterest
                                                        ) = $event),
                                              class: _normalizeClass({
                                                            'editable-field': _ctx.editMode,
                                                            modified:
                                                                props.item.modifiedFields.includes(
                                                                    'monthlyInterest',
                                                                ),
                                                            'hide-input': !_ctx.editMode,
                                                        }),
                                              density: "compact",
                                              type: "text",
                                              "hide-details": "",
                                              onInput: ($event: any) => (
                                                            _ctx.handleInput(
                                                                props.item,
                                                                'monthlyInterest',
                                                                $event,
                                                            )
                                                        ),
                                              onBlur: ($event: any) => (
                                                            _ctx.onBlurAction(
                                                                props.item,
                                                                'monthlyInterest',
                                                            )
                                                        )
                                            }, null, 8, ["aria-label", "modelValue", "onUpdate:modelValue", "class", "onInput", "onBlur"])
                                          ]),
                                          _createElementVNode("td", _hoisted_7, [
                                            _createVNode(_component_v_text_field, {
                                              "aria-label": 
                                                            _ctx.$t('emprunts.monthly-insurance')
                                                        ,
                                              modelValue: 
                                                            props.item.formattedValues
                                                                .monthlyInsurance
                                                        ,
                                              "onUpdate:modelValue": ($event: any) => ((
                                                            props.item.formattedValues
                                                                .monthlyInsurance
                                                        ) = $event),
                                              class: _normalizeClass({
                                                            'editable-field': _ctx.editMode,
                                                            modified:
                                                                props.item.modifiedFields.includes(
                                                                    'monthlyInsurance',
                                                                ),
                                                            'hide-input': !_ctx.editMode,
                                                        }),
                                              density: "compact",
                                              type: "text",
                                              "hide-details": "",
                                              onInput: ($event: any) => (
                                                            _ctx.handleInput(
                                                                props.item,
                                                                'monthlyInsurance',
                                                                $event,
                                                            )
                                                        ),
                                              onBlur: ($event: any) => (
                                                            _ctx.onBlurAction(
                                                                props.item,
                                                                'monthlyInsurance',
                                                            )
                                                        )
                                            }, null, 8, ["aria-label", "modelValue", "onUpdate:modelValue", "class", "onInput", "onBlur"])
                                          ]),
                                          _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.dueAmountEndPeriod,
                                                            undefined,
                                                        )), 1),
                                          _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.iraRedemptionAmount,
                                                            undefined,
                                                        )), 1)
                                        ], 2)
                                      ]),
                                      "body.append": _withCtx(() => [
                                        _createElementVNode("tr", _hoisted_10, [
                                          _cache[82] || (_cache[82] = _createElementVNode("td", { class: "text-left font-weight-bold" }, "Total", -1)),
                                          _cache[83] || (_cache[83] = _createElementVNode("td", { class: "text-left" }, null, -1)),
                                          _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.loanTotals().totalMonthlyPayments,
                                                        )), 1),
                                          _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.loanTotals().totalAmortisation,
                                                        )), 1),
                                          _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.loanTotals().totalInterest,
                                                        )), 1),
                                          _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.loanTotals().totalInsurance,
                                                        )), 1),
                                          _cache[84] || (_cache[84] = _createElementVNode("td", { class: "text-left" }, null, -1)),
                                          _cache[85] || (_cache[85] = _createElementVNode("td", { class: "text-left" }, null, -1))
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: 'display-accounting-lines' }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    (_ctx.document && _ctx.document.id)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "12",
                                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_component_accounting_item_static, {
                                              companyId: _ctx.selectedCompany?.id,
                                              documentId: _ctx.document?.id,
                                              mode: _ctx.isAccountingItem ? 'AllOption' : 'Embedded',
                                              ref: "accountingItemStatic",
                                              key: _ctx.accountingLinesRefreshKey,
                                              onUpsert: _ctx.onAccountingItemUpdated
                                            }, null, 8, ["companyId", "documentId", "mode", "onUpsert"]))
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: 'display-activity' }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    (_ctx.document && _ctx.document.id)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "12",
                                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_UsersActivitiesHistory, {
                                              documentId: _ctx.document?.id
                                            }, null, 8, ["documentId"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: 'display-pdf' }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    (_ctx.document && _ctx.document.id && _ctx.isPDF)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "12",
                                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ossPdf, {
                                              ref: "ossPdfRef",
                                              documentId: _ctx.document?.id
                                            }, null, 8, ["documentId"])
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_col, {
                                          key: 1,
                                          cols: "12",
                                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_15, [
                                              (_ctx.document)
                                                ? (_openBlock(), _createElementBlock("svg", {
                                                    key: 0,
                                                    id: "svg-document-loan",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "100%",
                                                    viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                                    style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                                  }, [
                                                    _createElementVNode("g", null, [
                                                      _createElementVNode("image", {
                                                        id: "svg-image-document-loan",
                                                        "xlink:href": _ctx.document.signedUrl,
                                                        x: "0",
                                                        y: "0",
                                                        height: `${_ctx.imageHeight}px`,
                                                        width: `${_ctx.imageWidth}px`
                                                      }, null, 8, _hoisted_17),
                                                      (!_ctx.showOCR)
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.deadlines, (deadline) => {
                                                            return (_openBlock(), _createElementBlock("polygon", {
                                                              key: `coord-${_ctx.document.id}-${deadline.index}`,
                                                              ref_for: true,
                                                              ref: `svg-loan-${deadline.index}`,
                                                              id: `svg-loan-${deadline.index}`,
                                                              points: 
                                                                        _ctx.getTokenPoints(deadline)
                                                                    ,
                                                              style: _normalizeStyle(
                                                                        deadline === _ctx.toEditDeadline
                                                                            ? 'fill:rgba(0,250,0,0.5);stroke:#F9B12A;stroke-width:1'
                                                                            : 'fill:rgba(0,250,0,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                                    ),
                                                              onClick: _withModifiers(($event: any) => (
                                                                        _ctx.toEditDeadline = deadline
                                                                    ), ["stop"]),
                                                              onMouseover: ($event: any) => (
                                                                        deadline.highlightBT(
                                                                            true,
                                                                            'identified',
                                                                        )
                                                                    ),
                                                              onMouseout: ($event: any) => (
                                                                        deadline.highlightBT(false)
                                                                    ),
                                                              class: _normalizeClass(
                                                                        deadline.focus
                                                                            ? 'highlighted'
                                                                            : !deadline.errorCount
                                                                              ? ''
                                                                              : 'error'
                                                                    )
                                                            }, null, 46, _hoisted_18))
                                                          }), 128))
                                                        : _createCommentVNode("", true),
                                                      (
                                                                _ctx.showOCR &&
                                                                _ctx.ocr &&
                                                                _ctx.ocr.sentences &&
                                                                _ctx.ocr.sentences.length
                                                            )
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.ocr.sentences, (sentence, sIndex) => {
                                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentence.tokens, (token, tIndex) => {
                                                                return (_openBlock(), _createElementBlock("polygon", {
                                                                  key: `sentence-${sIndex}-token-${tIndex}`,
                                                                  ref_for: true,
                                                                  ref: `sentence-${sIndex}-token-${tIndex}`,
                                                                  points: 
                                                                            _ctx.getTokenPoints(token)
                                                                        ,
                                                                  style: _normalizeStyle(
                                                                            _ctx.getTokenStyle(token)
                                                                        ),
                                                                  onMouseover: ($event: any) => (
                                                                            token.high = true
                                                                        ),
                                                                  onMouseout: ($event: any) => (
                                                                            token.high = false
                                                                        ),
                                                                  onClick: _withModifiers(($event: any) => (
                                                                            _ctx.onClickToken(token)
                                                                        ), ["stop"])
                                                                }, null, 44, _hoisted_19))
                                                              }), 128))
                                                            ], 64))
                                                          }), 256))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ], 8, _hoisted_16))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          class: "my-0 pl-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important","height":"calc(100vh - 82px)","overflow-y":"auto"},
              class: "default_card_wm elevation-0 rounded-l-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "9" }),
                        _createVNode(_component_v_col, {
                          cols: "3",
                          class: "mt-2 d-flex align-right justify-end"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.isInsideAccountingClosing)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  bottom: ""
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                      (_ctx.document && _ctx.document.id)
                                        ? (_openBlock(), _createBlock(_component_v_btn_edit, {
                                            key: 0,
                                            disabled: true,
                                            onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.valid()), ["stop"])),
                                            size: "small"
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_btn_add, {
                                            key: 1,
                                            disabled: true,
                                            onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.valid()), ["stop"])),
                                            size: "small"
                                          }))
                                    ], 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("emprunts.impossible")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.document && _ctx.document.id)
                                    ? (_openBlock(), _createBlock(_component_v_btn_edit, {
                                        key: 0,
                                        disabled: !_ctx.isValid,
                                        onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.valid()), ["stop"])),
                                        size: "small"
                                      }, null, 8, ["disabled"]))
                                    : (_openBlock(), _createBlock(_component_v_btn_add, {
                                        key: 1,
                                        disabled: !_ctx.isValid,
                                        onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.valid()), ["stop"])),
                                        size: "small"
                                      }, null, 8, ["disabled"]))
                                ], 64))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              class: "pt-0",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item mb-2",
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center",
                                              style: {"border-right":"1px #ededed solid"}
                                            }, {
                                              default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                _createElementVNode("b", null, "Nom", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.loan.title), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item mb-2",
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center",
                                              style: {"border-right":"1px #ededed solid"}
                                            }, {
                                              default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                _createElementVNode("b", null, "Statut", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                            _ctx.document.errorMessage &&
                                                            _ctx.reUploadDocument
                                                        )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t("emprunts.erreur")) + " : " + _toDisplayString(_ctx.document.errorMessage), 1))
                                                  : (
                                                            _ctx.document && _ctx.document.errorMessage
                                                        )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("emprunts.erreur-lecture")), 1))
                                                    : (
                                                            _ctx.document.status === 'ORIGINAL_UPLOADED'
                                                        )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, " En attente d'analyse "))
                                                      : (_ctx.document.status === 'UPLOADED')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, " En attente d'analyse "))
                                                        : (
                                                            !_ctx.document.id &&
                                                            _ctx.loan.status === 'ANALYSED'
                                                        )
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t("emprunts.en-cours-de-creation")), 1))
                                                          : (_ctx.document.status === 'VALIDATED')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Créé "))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_26, "OK"))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item my-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              style: {"border-right":"1px #ededed solid","height":"28px"},
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => _cache[88] || (_cache[88] = [
                                                _createElementVNode("b", null, "Type", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCategory(_ctx.loan.type)), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.activateTagguing)
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FreeTag, {
                                  companyTags: _ctx.allCompanyTags,
                                  document: _ctx.inDocument,
                                  splitUserPartitions: true,
                                  onChanged: _ctx.startToBeDoneIfNecessary,
                                  onOnTagsChanged: _ctx.upsertDocumentTags
                                }, null, 8, ["companyTags", "document", "onChanged", "onOnTagsChanged"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 title" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("emprunts.informations-emprunt")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_divider)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, {
                              modelValue: _ctx.formValid,
                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.formValid) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "mt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "8" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          modelValue: _ctx.loan.title,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.loan.title) = $event)),
                                          label: "Libellé",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          density: "compact"
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.loan.amortisationType,
                                          "onUpdate:modelValue": [
                                            _cache[23] || (_cache[23] = ($event: any) => ((_ctx.loan.amortisationType) = $event)),
                                            _cache[24] || (_cache[24] = ($event: any) => (_ctx.calculateMonthlyLoanRate()))
                                          ],
                                          items: _ctx.amortisationTypes,
                                          label: "Échéance",
                                          "item-value": "value",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          density: "compact",
                                          "item-title": (item) => item.text
                                        }, null, 8, ["modelValue", "items", "rules", "item-title"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "9" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          "onUpdate:modelValue": [
                                            _cache[25] || (_cache[25] = 
                                                    (value) => (_ctx.loan.invoiceNumber = String(value))
                                                ),
                                            _cache[26] || (_cache[26] = ($event: any) => ((_ctx.loan.invoiceNumber) = $event))
                                          ],
                                          modelValue: _ctx.loan.invoiceNumber,
                                          label: "Numéro de contrat",
                                          density: "compact",
                                          type: "text",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')]
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "3" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.loan.periodicity,
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.loan.periodicity) = $event)),
                                          label: _ctx.$t('emprunts.periodicite'),
                                          items: _ctx.periodicities
                                        }, null, 8, ["modelValue", "label", "items"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "pl-3",
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_oss_date_picker_filled, _mergeProps(props, {
                                              modelValue: _ctx.loan.signatureDate,
                                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.loan.signatureDate) = $event)),
                                              label: `Date de signature de l'emprunt`,
                                              textFieldReadOnly: false,
                                              "hide-details": ""
                                            }), null, 16, ["modelValue"])
                                          ]),
                                          default: _withCtx(() => [
                                            _cache[89] || (_cache[89] = _createElementVNode("span", null, "Date à laquelle l'emprunt a été signé.", -1))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      class: "pl-1",
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_oss_date_picker_filled, _mergeProps(props, {
                                              modelValue: _ctx.loan.startDate,
                                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.loan.startDate) = $event)),
                                              label: `Date de début de l'emprunt`,
                                              textFieldReadOnly: false,
                                              rules: [
                                                            (v) =>
                                                                !!v || _ctx.$t('settings.itemRequired'),
                                                        ],
                                              "hide-details": ""
                                            }), null, 16, ["modelValue", "rules"])
                                          ]),
                                          default: _withCtx(() => [
                                            _cache[90] || (_cache[90] = _createElementVNode("span", null, "Date à laquelle l'emprunt débute officiellement. Toutes les échéances sont calculées à partir de cette date.", -1))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "pl-3",
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_oss_date_picker_filled, _mergeProps(props, {
                                              modelValue: _ctx.loan.bobbeeStartDate,
                                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.loan.bobbeeStartDate) = $event)),
                                              label: 'Date de reprise dans bobbee',
                                              textFieldReadOnly: false,
                                              rules: [
                                                            (v) =>
                                                                !!v || _ctx.$t('settings.itemRequired'),
                                                        ],
                                              "hide-details": ""
                                            }), null, 16, ["modelValue", "rules"])
                                          ]),
                                          default: _withCtx(() => [
                                            _cache[91] || (_cache[91] = _createElementVNode("span", null, "Date de début de prise en compte sur bobbee. Les échéances entre cette date et la date de début ne sont pas comptabilisées dans bobbee, mais restent incluses dans le calcul.", -1))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      class: "pl-1",
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          label: "Nombre d'échéances",
                                          density: "compact",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          modelValue: _ctx.loan.loanPeriod,
                                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.loan.loanPeriod) = $event))
                                        }, null, 8, ["rules", "modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          modelValue: _ctx.loan.netAmount,
                                          "onUpdate:modelValue": [
                                            _cache[32] || (_cache[32] = ($event: any) => ((_ctx.loan.netAmount) = $event)),
                                            _cache[33] || (_cache[33] = ($event: any) => (
                                                    _ctx.onInputChanged($event, 'netAmount')
                                                ))
                                          ],
                                          label: "Montant de l'emprunt",
                                          density: "compact",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')]
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          label: "Taux d'emprunt ( % )",
                                          density: "compact",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          modelValue: _ctx.loan.loanRate,
                                          "onUpdate:modelValue": [
                                            _cache[34] || (_cache[34] = ($event: any) => ((_ctx.loan.loanRate) = $event)),
                                            _cache[35] || (_cache[35] = ($event: any) => (
                                                    _ctx.onInputChanged($event, 'loanRate')
                                                ))
                                          ]
                                        }, null, 8, ["rules", "modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          label: _ctx.$t('emprunts.taux-emprunt'),
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          modelValue: _ctx.loan.monthlyLoanRate,
                                          "onUpdate:modelValue": [
                                            _cache[36] || (_cache[36] = ($event: any) => ((_ctx.loan.monthlyLoanRate) = $event)),
                                            _cache[37] || (_cache[37] = ($event: any) => (
                                                    _ctx.onInputChanged($event, 'monthlyLoanRate')
                                                ))
                                          ]
                                        }, null, 8, ["label", "rules", "modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.loan.insuranceType,
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.loan.insuranceType) = $event)),
                                          items: _ctx.insuranceTypes,
                                          label: "Type d'assurance",
                                          "item-value": "value",
                                          "hide-details": "",
                                          density: "compact",
                                          "item-title": (item) => item.text
                                        }, null, 8, ["modelValue", "items", "item-title"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.loan.insuranceType === 'PERCENTAGE')
                                          ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                              key: 0,
                                              label: "Taux d'assurance ( % )",
                                              density: "compact",
                                              "hide-details": "",
                                              modelValue: _ctx.loan.insuranceRate,
                                              "onUpdate:modelValue": [
                                                _cache[39] || (_cache[39] = ($event: any) => ((_ctx.loan.insuranceRate) = $event)),
                                                _cache[40] || (_cache[40] = ($event: any) => (
                                                    _ctx.onInputChanged($event, 'insuranceRate')
                                                ))
                                              ]
                                            }, null, 8, ["modelValue"]))
                                          : (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                              key: 1,
                                              label: "Montant d'assurance",
                                              density: "compact",
                                              "hide-details": "",
                                              modelValue: _ctx.loan.insuranceAmount,
                                              "onUpdate:modelValue": [
                                                _cache[41] || (_cache[41] = ($event: any) => ((_ctx.loan.insuranceAmount) = $event)),
                                                _cache[42] || (_cache[42] = ($event: any) => (
                                                    _ctx.onInputChanged($event, 'insuranceAmount')
                                                ))
                                              ]
                                            }, null, 8, ["modelValue"]))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.loan.organisationType,
                                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.loan.organisationType) = $event)),
                                          items: _ctx.organisationTypes,
                                          label: "Organisme de prêt",
                                          "item-value": "value",
                                          "return-object": "",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          density: "compact",
                                          "item-title": (item) => item.text
                                        }, null, 8, ["modelValue", "items", "rules", "item-title"])
                                      ]),
                                      _: 1
                                    }),
                                    (
                                                _ctx.loan.organisationType &&
                                                _ctx.loan.organisationType.value === 'BANK'
                                            )
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "8"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, {
                                              modelValue: _ctx.loan.bankAccount.name,
                                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.loan.bankAccount.name) = $event)),
                                              label: "Banque",
                                              density: "compact",
                                              "hide-details": "",
                                              readonly: "",
                                              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.bankDialog = true))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_col, {
                                          key: 1,
                                          cols: "8"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, {
                                              label: "Fournisseur",
                                              "hide-details": "",
                                              readonly: "",
                                              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.thirdPartyCompanyDialog = true)),
                                              "model-value": _ctx.loan.thirdPartyCompany.name,
                                              density: "compact"
                                            }, null, 8, ["model-value"])
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_row, { class: "mt-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_AccountableAccount, {
                                      showLabel: true,
                                      label: `Compte d'intérêts`,
                                      showValidation: false,
                                      companyId: _ctx.companyId,
                                      showDescription: true,
                                      inAccountableAccountType: 'Selected',
                                      inAccountableAccountNames: ['661100'],
                                      inAccountableAccount: _ctx.accountableAccountInterest,
                                      disabled: false,
                                      onSelectAccountableAccount: 
                                                _ctx.selectAccountableAccountInterest
                                            ,
                                      defineThirdParty: false,
                                      dense: ""
                                    }, null, 8, ["companyId", "inAccountableAccount", "onSelectAccountableAccount"]), [
                                      [_vShow, true]
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_AccountableAccount, {
                                      showLabel: true,
                                      label: `Compte d'assurances`,
                                      showValidation: false,
                                      companyId: _ctx.companyId,
                                      showDescription: true,
                                      inAccountableAccountType: 'Selected',
                                      inAccountableAccountNames: ['616'],
                                      inAccountableAccount: _ctx.accountableAccountInsurance,
                                      disabled: false,
                                      onSelectAccountableAccount: 
                                                _ctx.selectAccountableAccountInsurance
                                            ,
                                      defineThirdParty: false,
                                      dense: ""
                                    }, null, 8, ["companyId", "inAccountableAccount", "onSelectAccountableAccount"]), [
                                      [_vShow, true]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.analysis)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DocumentLoanOCR, {
                                  document: _ctx.document,
                                  analysis: _ctx.analysis,
                                  deadlines: _ctx.deadlines
                                }, null, 8, ["document", "analysis", "deadlines"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.localEnv === 'dev')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 title" }, {
                              default: _withCtx(() => _cache[92] || (_cache[92] = [
                                _createTextVNode(" Informations de renégociation ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "mt-2 pt-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.loan.loanEarlyRedemptionNegociation,
                                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.loan.loanEarlyRedemptionNegociation) = $event)),
                                          label: "Renégociation",
                                          "hide-details": "",
                                          density: "compact"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        (_ctx.loan.loanEarlyRedemptionNegociation)
                                          ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                              key: 0,
                                              modelValue: _ctx.loan.negociationType,
                                              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.loan.negociationType) = $event)),
                                              items: _ctx.negociationTypes,
                                              label: "Type renégociation",
                                              "item-value": "value",
                                              "hide-details": "",
                                              density: "compact",
                                              "item-title": (item) => item.text
                                            }, null, 8, ["modelValue", "items", "item-title"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.loan.loanEarlyRedemptionNegociation)
                                          ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                              key: 0,
                                              modelValue: _ctx.loan.negociationDate,
                                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.loan.negociationDate) = $event)),
                                              items: _ctx.negociationDates,
                                              label: "Date de renégociation",
                                              "item-value": "value",
                                              "hide-details": "",
                                              density: "compact",
                                              "item-title": (item) => item.text
                                            }, null, 8, ["modelValue", "items", "item-title"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (
                                                _ctx.loan.loanEarlyRedemptionNegociation &&
                                                _ctx.loan.negociationType &&
                                                _ctx.loan.negociationType === 'RATE'
                                            )
                                          ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                              key: 0,
                                              modelValue: _ctx.loan.negociationRate,
                                              "onUpdate:modelValue": [
                                                _cache[51] || (_cache[51] = ($event: any) => ((_ctx.loan.negociationRate) = $event)),
                                                _cache[52] || (_cache[52] = ($event: any) => (
                                                _ctx.onInputChanged($event, 'negociationRate')
                                            ))
                                              ],
                                              label: "Taux renégocié",
                                              density: "compact",
                                              "hide-details": ""
                                            }, null, 8, ["modelValue"]))
                                          : (
                                                _ctx.loan.loanEarlyRedemptionNegociation &&
                                                _ctx.loan.negociationType &&
                                                _ctx.loan.negociationType === 'DURATION'
                                            )
                                            ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                key: 1,
                                                modelValue: _ctx.loan.negociationPeriod,
                                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.loan.negociationPeriod) = $event)),
                                                label: "Échéances restantes",
                                                density: "compact",
                                                "hide-details": ""
                                              }, null, 8, ["modelValue"]))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 title" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("emprunts.informations-rachat")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_divider)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  class: "mt-2 pt-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_switch, {
                                      modelValue: _ctx.loan.loanEarlyRedemption,
                                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.loan.loanEarlyRedemption) = $event)),
                                      label: "Remboursement anticipé",
                                      "hide-details": "",
                                      density: "compact"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    (_ctx.loan.loanEarlyRedemption)
                                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                          key: 0,
                                          modelValue: _ctx.loan.redemptionType,
                                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.loan.redemptionType) = $event)),
                                          items: _ctx.redemptionTypes,
                                          label: "Type remboursement",
                                          "item-value": "value",
                                          "hide-details": "",
                                          density: "compact",
                                          "item-title": (item) => item.text
                                        }, null, 8, ["modelValue", "items", "item-title"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  class: "pl-1"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.loan.loanEarlyRedemption)
                                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                          key: 0,
                                          modelValue: _ctx.loan.loanEarlyRedemptionDate,
                                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.loan.loanEarlyRedemptionDate) = $event)),
                                          items: _ctx.loanEarlyRedemptionDates,
                                          label: "Date de remboursement",
                                          "item-value": "value",
                                          "hide-details": "",
                                          density: "compact",
                                          "item-title": (item) => item.text
                                        }, null, 8, ["modelValue", "items", "item-title"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { class: "mt-2" }, {
                              default: _withCtx(() => [
                                (_ctx.loan.loanEarlyRedemption)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.loan.loanEarlyRedemption)
                                          ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                              key: 0,
                                              label: "Montant remboursement",
                                              density: "compact",
                                              "hide-details": "",
                                              modelValue: _ctx.loan.earlyRedemptionAmount,
                                              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.loan.earlyRedemptionAmount) = $event))
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.loan.loanEarlyRedemption)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.loan.loanEarlyRedemption)
                                          ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                              key: 0,
                                              label: "Montant IRA",
                                              density: "compact",
                                              "hide-details": "",
                                              modelValue: _ctx.loan.iraRedemptionAmount,
                                              "onUpdate:modelValue": [
                                                _cache[58] || (_cache[58] = ($event: any) => ((_ctx.loan.iraRedemptionAmount) = $event)),
                                                _cache[59] || (_cache[59] = ($event: any) => (
                                                _ctx.onInputChanged($event, 'iraRedemptionAmount')
                                            ))
                                              ]
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.isPartialRedemption)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 2,
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          label: "Montant intérêts",
                                          density: "compact",
                                          "hide-details": "",
                                          modelValue: _ctx.loan.earlyRedemptionInterest,
                                          "onUpdate:modelValue": [
                                            _cache[60] || (_cache[60] = ($event: any) => ((_ctx.loan.earlyRedemptionInterest) = $event)),
                                            _cache[61] || (_cache[61] = ($event: any) => (
                                                _ctx.onInputChanged($event, 'earlyRedemptionInterest')
                                            ))
                                          ]
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.isPartialRedemption)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 3,
                                      cols: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          label: "Montant assurances",
                                          density: "compact",
                                          "hide-details": "",
                                          modelValue: _ctx.loan.earlyRedemptionInsurance,
                                          "onUpdate:modelValue": [
                                            _cache[62] || (_cache[62] = ($event: any) => ((_ctx.loan.earlyRedemptionInsurance) = $event)),
                                            _cache[63] || (_cache[63] = ($event: any) => (
                                                _ctx.onInputChanged($event, 'earlyRedemptionInsurance')
                                            ))
                                          ]
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            (_ctx.loan.loanEarlyRedemption)
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 0,
                                  class: "mt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_AccountableAccount, {
                                          showLabel: true,
                                          label: `Compte d'IRA`,
                                          inputStyle: 'padding:0px; margin:0px;',
                                          showValidation: false,
                                          companyId: _ctx.companyId,
                                          showDescription: true,
                                          inAccountableAccountType: 'Selected',
                                          inAccountableAccountNames: ['627'],
                                          inAccountableAccount: _ctx.accountableAccountIRA,
                                          disabled: false,
                                          hideDetails: true,
                                          onSelectAccountableAccount: _ctx.selectAccountableAccountIRA,
                                          defineThirdParty: false,
                                          dense: ""
                                        }, null, 8, ["companyId", "inAccountableAccount", "onSelectAccountableAccount"]), [
                                          [_vShow, true]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mt-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_prev, {
                              disabled: _ctx.previousDisabled(),
                              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.previous()))
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_v_btn_next, {
                              disabled: _ctx.nextDisabled(),
                              onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.next()))
                            }, null, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      error: true,
      onValid: _ctx.deleteDocument,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.$t("emprunts.supr-doc")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.restoreDialog,
      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.restoreDialog) = $event)),
      title: "Restaurer le document",
      onValid: _cache[68] || (_cache[68] = ($event: any) => {
                _ctx.restoreDocument();
                _ctx.restoreDialog = false;
            }),
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.restoreLoading,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.$t("emprunts.rest-doc")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "validLoading"]),
    (_ctx.document.id)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.uploadDocumentDialog,
          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.uploadDocumentDialog) = $event)),
          title: _ctx.$t('emprunts.import-doc'),
          "max-width": "60vw",
          actions: _ctx.actions
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UploadDocument, {
              showFirstPrevious: false,
              companyId: _ctx.companyId,
              documentId: _ctx.document?.id,
              documentType: 'MISCELLANEOUS',
              multiple: false,
              actions: _ctx.actions,
              freeTag: false,
              showBtns: true,
              onFileUploaded: _cache[69] || (_cache[69] = ($event: any) => {
                    _ctx.closeUploadDocumentDialog();
                    _ctx.startToBeDoneIfNecessary();
                })
            }, null, 8, ["companyId", "documentId", "actions"])
          ]),
          _: 1
        }, 8, ["modelValue", "title", "actions"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.thirdPartyCompanyDialog,
      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.thirdPartyCompanyDialog) = $event)),
      title: _ctx.$t('emprunts.choisir-fournisseur'),
      "max-width": "60vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompaniesTable, {
          modelValue: _ctx.loan.thirdPartyCompany,
          "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.loan.thirdPartyCompany) = $event)),
          parentCompanyId: _ctx.companyId,
          showGenericCompany: false,
          showConsumerCompany: false,
          showCustomerCompanies: false,
          showSupplierCompanies: true,
          showExistingCompanies: true,
          showNewCompanies: true,
          onSelectCompany: _ctx.selectThirdPartyCompany
        }, null, 8, ["modelValue", "parentCompanyId", "onSelectCompany"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.bankDialog,
      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.bankDialog) = $event)),
      title: _ctx.$t('emprunts.choisir-banque'),
      "max-width": "60vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BankAccountSelector, {
          modelValue: _ctx.loan.bankAccount,
          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.loan.bankAccount) = $event)),
          companyId: _ctx.companyId,
          onSelectBank: _ctx.selectBankAccount
        }, null, 8, ["modelValue", "companyId", "onSelectBank"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.analyseDocumentDialog,
      "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.analyseDocumentDialog) = $event)),
      title: "Relancer l'analyse du document",
      onValid: _ctx.analyseDocument,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[93] || (_cache[93] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir relancer l'analyse ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid"])
  ]))
}